module.exports = __webpack_public_path__ + "static/map-ab45c552dd3e9cb65d567eb6d9d575aa.png";